export const sftpFields = {
  download: [
    {
      field: "filePath",
      label: "File path (with file name)",
      type: "text",
      placeholder: "File path (with file name) eg. /path/to/file.txt",
      isRequired: true,
    },
  ],
  list: [
    {
      field: "listPath",
      label: "Path",
      type: "text",
      placeholder: "eg. /path/to/files",
      isRequired: true,
    },
  ],
  upload: [
    { field: "file", label: "File", type: "file", multiple: false, isRequired: true },
    {
      field: "uploadFilePath",
      label: "File path",
      type: "text",
      placeholder: "eg. /path/of/file",
      isRequired: true,
    },
  ],
};
